import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const UPLOAD_CSV_CLIENTS = createAsyncActionType('UPLOAD_CSV_CLIENTS');


// WEBPACK FOOTER //
// ./src/features/score-card/types/uploadCsvClientsTypes.js